import React from 'react';
import { useNavigate } from 'react-router-dom';

const Welcome = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="max-w-5xl w-full text-center space-y-12">
        <div className="space-y-6">
          <h1 className="text-6xl font-bold text-gray-900 tracking-tight">
            Welcome to <span className="text-indigo-600">JobGenius</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Your AI-powered career companion. Discover opportunities, prepare for interviews, and track your journey to success.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <button
            onClick={() => navigate('/register')}
            className="w-64 py-4 bg-indigo-600 text-white rounded-xl font-semibold text-lg shadow-lg hover:bg-indigo-700 transform transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
          >
            Get Started
          </button>
          <button
            onClick={() => navigate('/recruiter-login')}
            className="w-64 py-4 bg-white text-indigo-600 border-2 border-indigo-600 rounded-xl font-semibold text-lg hover:bg-indigo-50 transform transition-all duration-300 hover:-translate-y-1"
          >
            Recruiter Login
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="p-6 bg-gray-50 rounded-2xl">
            <div className="text-indigo-600 text-4xl mb-4">🎯</div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Smart Job Matching</h3>
            <p className="text-gray-600">AI-powered job recommendations tailored to your skills and preferences</p>
          </div>
          <div className="p-6 bg-gray-50 rounded-2xl">
            <div className="text-indigo-600 text-4xl mb-4">🤖</div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">AI Interview Prep</h3>
            <p className="text-gray-600">Practice with our AI interviewer and get real-time feedback</p>
          </div>
          <div className="p-6 bg-gray-50 rounded-2xl">
            <div className="text-indigo-600 text-4xl mb-4">📊</div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Career Analytics</h3>
            <p className="text-gray-600">Track your applications and analyze your progress</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;